// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 1H14V5H10V1ZM2 6H22V8.6594L15 11.6594V17H15.7808L17.2808 23H6.71922L8.21922 17H9V11.6594L2 8.6594V6ZM9 9.48346V8H5.53859L9 9.48346ZM11 8V10.5858L13 12.5858V8H11ZM15 8V9.48346L18.4614 8H15ZM13 15.4142L11 13.4142V17H13V15.4142Z"}}]};

const StatueOfJesusFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'statue-of-jesus-filled',
    ref,
    icon: element,
  },
));

StatueOfJesusFilledIcon.displayName = 'StatueOfJesusFilledIcon';

export default StatueOfJesusFilledIcon;
